import React, { Fragment } from "react";
import Layout from "../layout";

const TermsOfService = () => {
  return (
    <Fragment>
      <Layout>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/30 py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Header Section */}
            <div className="bg-white/90 backdrop-blur-lg rounded-3xl shadow-2xl border-2 border-blue-100 p-8 md:p-12 mb-8">
              <div className="text-center mb-8">
                <div className="inline-block p-4 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full mb-6">
                  <svg className="w-16 h-16 text-blue-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h1 className="text-4xl md:text-5xl font-black bg-blue-800 from-blue-800 via-purple-700 to-pink-600 bg-clip-text text-white mb-4">
                  Conditions d'utilisation
                </h1>
                <p className="text-gray-600 text-lg font-medium">
                  Dernière mise à jour : <span className="text-blue-600 font-bold">15 novembre 2024</span>
                </p>
              </div>

              {/* Introduction */}
              <div className="prose prose-lg max-w-none">
                <p className="text-gray-700 leading-relaxed mb-6">
                  Bienvenue sur <span className="font-bold text-blue-600">JamaalStore</span>. En accédant et en utilisant notre site web et nos services, 
                  vous acceptez d'être lié par les présentes conditions d'utilisation. Veuillez les lire attentivement.
                </p>
              </div>
            </div>

            {/* Terms Sections */}
            <div className="space-y-6">
              {/* Section 1 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">1</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Acceptation des conditions</h2>
                </div>
                <p className="text-gray-700 leading-relaxed ml-14">
                  En utilisant JamaalStore, vous confirmez que vous avez au moins 18 ans ou que vous utilisez le site 
                  sous la supervision d'un parent ou d'un tuteur légal. Vous acceptez de respecter toutes les lois 
                  et réglementations applicables.
                </p>
              </div>

              {/* Section 2 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">2</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Utilisation du site</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>Vous vous engagez à utiliser le site uniquement à des fins légales et de manière à ne pas porter atteinte aux droits de tiers.</p>
                  <p className="font-semibold text-gray-800">Il est interdit de :</p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Utiliser le site de manière frauduleuse ou à des fins illicites</li>
                    <li>Tenter d'accéder aux zones restreintes du site</li>
                    <li>Transmettre des virus ou des codes malveillants</li>
                    <li>Reproduire, copier ou revendre tout contenu sans autorisation</li>
                  </ul>
                </div>
              </div>

              {/* Section 3 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-pink-500 to-red-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">3</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Compte utilisateur</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>Pour passer commande, vous devez créer un compte. Vous êtes responsable de :</p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>La confidentialité de vos identifiants de connexion</li>
                    <li>Toutes les activités effectuées via votre compte</li>
                    <li>Informer immédiatement JamaalStore en cas d'utilisation non autorisée</li>
                  </ul>
                  <p className="mt-4">
                    Nous nous réservons le droit de suspendre ou de fermer votre compte en cas de violation des présentes conditions.
                  </p>
                </div>
              </div>

              {/* Section 4 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">4</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Commandes et paiements</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>Toutes les commandes sont soumises à acceptation et disponibilité des produits.</p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Les prix sont indiqués en devise locale et incluent toutes les taxes applicables</li>
                    <li>Le paiement doit être effectué au moment de la commande</li>
                    <li>Nous acceptons les paiements par carte bancaire et autres moyens indiqués sur le site</li>
                    <li>Nous nous réservons le droit d'annuler toute commande en cas de suspicion de fraude</li>
                  </ul>
                </div>
              </div>

              {/* Section 5 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-green-500 to-teal-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">5</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Livraison</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>Les délais de livraison sont donnés à titre indicatif et peuvent varier selon la destination.</p>
                  <p>JamaalStore ne peut être tenu responsable des retards de livraison dus à des circonstances indépendantes de sa volonté.</p>
                </div>
              </div>

              {/* Section 6 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">6</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Retours et remboursements</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>Conformément à la législation en vigueur, vous disposez d'un délai de 7 jours pour retourner un produit.</p>
                  <ul className="list-disc ml-6 space-y-2">
                    <li>Le produit doit être dans son emballage d'origine, non utilisé</li>
                    <li>Les frais de retour sont à la charge du client sauf en cas de défaut</li>
                    <li>Le remboursement sera effectué dans un délai de 7 jours après réception du retour</li>
                  </ul>
                </div>
              </div>

              {/* Section 7 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">7</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Propriété intellectuelle</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>
                    Tous les contenus présents sur le site (textes, images, logos, vidéos) sont la propriété exclusive 
                    de JamaalStore et sont protégés par les lois sur la propriété intellectuelle.
                  </p>
                  <p>
                    Toute reproduction, distribution ou utilisation non autorisée est strictement interdite.
                  </p>
                </div>
              </div>

              {/* Section 8 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-red-500 to-pink-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">8</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Limitation de responsabilité</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>
                    JamaalStore s'efforce de maintenir le site accessible 24h/24, mais ne peut garantir une disponibilité 
                    permanente. Nous ne saurions être tenus responsables des dommages résultant de l'utilisation ou de 
                    l'impossibilité d'utiliser le site.
                  </p>
                </div>
              </div>

              {/* Section 9 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-teal-500 to-green-500 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">9</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Modifications des conditions</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>
                    JamaalStore se réserve le droit de modifier les présentes conditions à tout moment. 
                    Les modifications entreront en vigueur dès leur publication sur le site. Il est de votre 
                    responsabilité de consulter régulièrement ces conditions.
                  </p>
                </div>
              </div>

              {/* Section 10 */}
              <div className="bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8 hover:shadow-2xl transition-shadow duration-300">
                <div className="flex items-start mb-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-gray-600 to-gray-800 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold text-lg">10</span>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800 mt-1">Contact</h2>
                </div>
                <div className="text-gray-700 leading-relaxed ml-14 space-y-3">
                  <p>Pour toute question concernant ces conditions d'utilisation, vous pouvez nous contacter :</p>
                  <ul className="space-y-2">
                    <li className="flex items-center">
                      <svg className="w-5 h-5 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                      <span className="font-semibold">Email :</span> <a href="mailto:contact@jamaalstore.com" className="text-blue-600 hover:underline ml-2">contact@jamaalstore.com</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="mt-12 text-center bg-yellow-300 from-blue-50 to-purple-50 rounded-2xl p-8 border border-blue-100">
              <p className="text-gray-600 mb-4">
                En continuant à utiliser JamaalStore, vous acceptez les présentes conditions d'utilisation.
              </p>
              <a
                href="/"
                className="inline-block bg-blue-800 from-blue-600 to-purple-600 text-white font-bold py-3 px-8 rounded-full hover:from-blue-700 hover:to-purple-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
              >
                Retour à l'accueil
              </a>
            </div>
          </div>
        </div>
      </Layout>
    </Fragment>
  );
};

export default TermsOfService;
